import axios from "./axiosInstance";

const EnquiryFormAPI = {
  postEnquiry: (payload) => axios.post(`/enquiry`, payload),
};

export default EnquiryFormAPI;